import React from 'react';
import './partners.css';
import DomoticNavbar from '../Components/Navbar';

// Importación de imágenes locales (debes colocar estas imágenes en la carpeta correspondiente)
import CiscoLogo from "./img_marcas/cisco.png";
import HikvisionLogo from "./img_marcas/imgNuevas/MARCAS/HIKVISION.png";
import HanwhaLogo from "./img_marcas/imgNuevas/MARCAS/FORTINET.png";
import ZKTecoLogo from "./img_marcas/imgNuevas/MARCAS/ZKTECO.png";
import ViewSonicLogo from "./img_marcas/imgNuevas/MARCAS/VIEWSONIC.png";
import DellLogo from "./img/img_marcas/dell.png";
import HPLogo from "./img/img_marcas/hp.png";
import LenovoLogo from "./img/img_marcas/lenovo.png";
import LGLogo from "./img_marcas/lg.png";
import RuijieLogo from "./img_marcas/imgNuevas/MARCAS/RUIJIE.png";
import IntelbrasLogo from "./img_marcas/imgNuevas/MARCAS/INTELBRAS.png";
import SEIPLogo from "./img_marcas/SOPHOS.png";
import LocherLogo from "./img_marcas/INSTEON.png";
import IsdeLogo from "./img_marcas/ISDE.png"
const Partners = () => {
  // Lista completa de partners con imágenes locales
  const partners = [
    {
      name: "Cisco",
      logo: CiscoLogo,
      website: "https://www.cisco.com/",
      description: "Líder mundial en redes y comunicaciones.",
      since: "2015",
      achievements: [
        "Certified",
        "Premio a la Excelencia en Implementaciones 2022"
      ]
    },
    {
      name: "Hikvision",
      logo: HikvisionLogo,
      website: "https://www.hikvision.com/",
      description: "Canal de proyectos y formación técnica - Innovador líder en videovigilancia.",
      since: "2016",
      achievements: [
        "",
        "Centro de Demostración Certificado"
      ]
    },
    {
      name: "Fortinet",
      logo: HanwhaLogo,
      website: "https://www.fortinet.com/",
      description: "Canal de Ciberseguridad y Networking.",
      since: "2018",
      achievements: [
        "Partner Certificado",
        "Especialistas en soluciones técnicas"
      ]
    },
    {
      name: "ZKTeco",
      logo: ZKTecoLogo,
      website: "https://www.zkteco.com/",
      description: " Soluciones de control de acceso y biometría.",
      since: "2017",
      achievements: [
        "Partner Oficial",
        "Certificación en sistemas biométricos"
      ]
    },
    {
      name: "ViewSonic",
      logo: ViewSonicLogo,
      website: "https://www.viewsonic.com/",
      description: " Soluciones visuales y displays profesionales.",
      since: "2019",
      achievements: [
        "Partner Autorizado",
        "Especialistas en soluciones visuales"
      ]
    },
    {
      name: "Dell",
      logo: DellLogo,
      website: "https://www.dell.com/",
      description: "Tecnología y soluciones empresariales.",
      since: "2017",
      achievements: [
        "Partner Certificado",
        "Proveedor de soluciones empresariales"
      ]
    },
    {
      name: "HP",
      logo: HPLogo,
      website: "https://www.hp.com/",
      description: " Soluciones de impresión y computación.",
      since: "2016",
      achievements: [
        "Partner Oficial",
        "Especialistas en equipos empresariales"
      ]
    },
    {
      name: "Lenovo",
      logo: LenovoLogo,
      website: "https://www.lenovo.com/",
      description: "Equipos y soluciones de computación.",
      since: "2018",
      achievements: [
        "Partner Autorizado",
        "Soluciones empresariales certificadas"
      ]
    },
    {
      name: "LG",
      logo: LGLogo,
      website: "https://www.lg.com/",
      description: "Soluciones de visualización y electrónica.",
      since: "2019",
      achievements: [
        "Partner Comercial",
        "Especialistas en displays profesionales"
      ]
    },
    {
      name: "Ruijie Networks",
      logo: RuijieLogo,
      website: "https://www.ruijienetworks.com/",
      description: " Soluciones de networking y conectividad.",
      since: "2020",
      achievements: [
        "Partner Certificado",
        "Soluciones de networking empresarial"
      ]
    },
    {
      name: "Intelbras",
      logo: IntelbrasLogo,
      website: "https://www.intelbras.com/",
      description: " Soluciones de seguridad y telecomunicaciones.",
      since: "2018",
      achievements: [
        "Partner Oficial",
        "Especialistas en seguridad electrónica"
      ]
    },
    {
      name: "SOPHOS",
      logo: SEIPLogo,
      website: "https://www.sophos.com/",
      description: "Software especializado",
      since: "2019",
      achievements: [
        "Distribuidor Autorizado",
        "Especialistas en puertas de seguridad"
      ]
    },
    {
      name: "INSTEON",
      logo: LocherLogo,
      website: "https://www.insteon.com/",
      description: "Automatizacion y Domotica .",
      since: "2020",
      achievements: [
        "Partner Comercial",
        "Soluciones de seguridad certificadas"
      ]
    },
    {
      name: "ISDE",
      logo: IsdeLogo,
      website: "https://www.isde.com/",
      description: "Equipos y Soluciones.",
      since: "2021",
      achievements: [
        "Partner Estratégico",
        "Equipos y Soluciones"
      ]
    }
  ];

  return (
    <div className="partners">
      <DomoticNavbar/>
      
      <header className="partners__header">
        <div className="partners__header-content">
          <h1 className="partners__title">NUESTROS <span>PARTNERS</span> Y MARCAS</h1>
          <p className="partners__subtitle">Estamos acreditados y certificados con las diferentes marcas líderes del mercado</p>
        </div>
      </header>

      <section className="partners__intro">
        <div className="partners__container">
          <h2 className="partners__section-title">ALIANZAS ESTRATÉGICAS</h2>
          <p className="partners__intro-text">
            Nuestras relaciones privilegiadas con los principales fabricantes nos permiten ofrecer 
            soluciones tecnológicas de vanguardia, con certificaciones exclusivas y soporte técnico 
            especializado para cada proyecto.
          </p>
        </div>
      </section>

      <section className="partners__grid">
        <div className="partners__container">
          <div className="partners-grid">
            {partners.map((partner, index) => (
              <div className="partner-card" key={index}>
                <a href={partner.website} target="_blank" rel="noopener noreferrer" className="partner-link">
                  <div className="partner-logo-container">
                    <img 
                      src={partner.logo} 
                      alt={`Logo de ${partner.name}`} 
                      className="partner-logo"
                      loading="lazy"
                    />
                  </div>
                  <h3 className="partner-name">{partner.name}</h3>
                  <p className="partner-description">{partner.description}</p>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="partners__benefits">
        <div className="partners__container">
          <h2 className="partners__section-title">BENEFICIOS DE NUESTRAS ALIANZAS</h2>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-card__icon">🏆</div>
              <h3 className="benefit-card__title">Certificaciones Oficiales</h3>
              <p className="benefit-card__text">Contamos con las certificaciones más importantes de cada fabricante.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card__icon">🔧</div>
              <h3 className="benefit-card__title">Soporte Técnico Especializado</h3>
              <p className="benefit-card__text">Acceso directo a equipos técnicos y de desarrollo de los fabricantes.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card__icon">💼</div>
              <h3 className="benefit-card__title">Condiciones Comerciales Preferentes</h3>
              <p className="benefit-card__text">Acceso a programas de incentivos y condiciones especiales exclusivas.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card__icon">📚</div>
              <h3 className="benefit-card__title">Formación Continua</h3>
              <p className="benefit-card__text">Capacitación técnica constante sobre las últimas tecnologías.</p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Partners;